import React, { useEffect } from 'react';
import {
    changeDepartment1All,
    changeDepartment2All,
    changeAddressAll,
    changePhoneAll,
    changeFaxAll,
    changeCityAll,
    changeStateAll,
    changeZipAll,
    changeSuiteRoomAll,
    getAddressLineP18T3,
} from './../CanvasActions';
import TextField from './../Form/TextField';
import SelectField from './../Form/SelectField';

const FormP18T3 = React.memo((props) => {
    useEffect(() => {
        changeDepartment1All(props.department1);
    }, [props.department1]);

    useEffect(() => {
        changeDepartment2All(props.department2);
    }, [props.department2]);

    useEffect(() => {
        changePhoneAll(props.phone);
    }, [props.phone]);

    useEffect(() => {
        changeFaxAll(props.fax);
    }, [props.fax]);

    useEffect(() => {
        changeAddressAll(props.address);
    }, [props.address]);

    useEffect(() => {
        changeCityAll(props.city);
    }, [props.city]);

    useEffect(() => {
        changeStateAll(props.state);
    }, [props.state]);

    useEffect(() => {
        changeZipAll(props.zip);
    }, [props.zip]);

    const handleSetAddress = (value) => {
        changeAddressAll(value);
        const address = getAddressLineP18T3();

        if (address.length > 67) {
            props.setAddress(props.address);
            changeAddressAll(props.address);
        } else {
            props.setAddress(value);
        }
    };

    const handleSetSuiteRoom = (value) => {
        changeSuiteRoomAll(value);
        const address = getAddressLineP18T3();

        if (address.length > 67) {
            props.setSuiteRoom(props.suiteRoom);
            changeSuiteRoomAll(props.suiteRoom);
        } else {
            props.setSuiteRoom(value);
        }
    };

    const handleSetCity = (value) => {
        changeCityAll(value);
        const address = getAddressLineP18T3();

        if (address.length > 67) {
            props.setCity(props.city);
            changeCityAll(props.city);
        } else {
            props.setCity(value);
        }
    };

    const handleSetZip = (value) => {
        changeZipAll(value);
        const address = getAddressLineP18T3();

        if (address.length > 67) {
            props.setZip(props.zip);
            changeZipAll(props.zip);
        } else {
            props.setZip(value);
        }
    };

    return (
        <form action="" className="form-container">
            <hr />
            <TextField
                required
                label="Clinic Name 1"
                limit="55"
                value={props.department1}
                setFunction={props.setDepartment1}
                placeholder="Clinic Name Line 1"
            />
            <TextField
                label="Clinic Name 2"
                limit="55"
                value={props.department2}
                setFunction={props.setDepartment2}
                placeholder="Clinic Name Line 2"
            />
            <hr />
            <TextField
                required
                label="Address"
                value={props.address}
                setFunction={handleSetAddress}
                placeholder="Address"
            />
            <TextField
                label="Suite #"
                value={props.suiteRoom}
                setFunction={handleSetSuiteRoom}
                placeholder="Suite/Building #"
            />
            <TextField
                required
                label="City"
                value={props.city}
                setFunction={handleSetCity}
            />
            <TextField
                required
                label="Zip"
                value={props.zip}
                setFunction={handleSetZip}
            />
            <hr />
            <TextField
                required
                isPhone
                phoneFormat={3}
                label="Phone"
                limit="12"
                value={props.phone}
                setFunction={props.setPhone}
                placeholder="Main or direct phone number"
            />
            <TextField
                isPhone
                phoneFormat={3}
                label="Fax"
                limit="12"
                value={props.fax}
                setFunction={props.setFax}
                placeholder="Fax number"
            />
            <hr />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: '', label: 'Select option' },
                    { value: '1', label: '1 bundle (5 pieces)' },
                    { value: '2', label: '2 bundles (10 pieces)' },
                    { value: '3', label: '3 bundles (15 pieces)' },
                    { value: '4', label: '4 bundles (20 pieces)' },
                    { value: '5', label: '5 bundles (25 pieces)' },
                    { value: '6', label: '6 bundles (30 pieces)' },
                    { value: '7', label: '7 bundles (35 pieces)' },
                    { value: '8', label: '8 bundles (40 pieces)' },
                    { value: '9', label: '9 bundles (45 pieces)' },
                    { value: '10', label: '10 bundles (50 pieces)' },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> Co-branded Clinic Notepad</div>
                <div className="mt-2">
                    <span className="label">Description:</span> This tear-off notepad can be customized with your clinic information,
                    including location name, address, phone and fax number. The notepad is also conveniently sized to fit in the
                    pockets of standard white coats.
                </div>
                <div className="description-list">
                    <span className="label">Specs:</span>
                    <ul>
                        <li>Variable on front</li>
                        <li>Size: 5.5x4"</li>
                        <li>Color: One color, black ink</li>
                        <li>Paper: 60# Offset</li>
                        <li>One-sided</li>
                        <li>50 sheets per pad with glue and cardboard backing</li>
                    </ul>
                </div>
            </div>
        </form>
    );
});

export default FormP18T3;
